// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".team__title[data-v-9c753d0e]{line-height:1.4;font-weight:600}.team__image[data-v-9c753d0e]{border-radius:50%}.team__image--next[data-v-9c753d0e]{transform:translateX(-7px)}.team__more[data-v-9c753d0e]{font-size:.8125rem;line-height:1.2;width:-moz-max-content;width:max-content}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
